// wiederverwendbare Funktion
const sendTrackingData  = (params) => {
    const url = new URL('trackclick', window.location.origin);
    url.searchParams.set('loc', window.location.href);
  
    for (const key in params) {
        if (params[key] != null) {
            url.searchParams.set(key, params[key]);
        }
    }

    fetch(url.toString());
};

document.addEventListener('DOMContentLoaded', function () {
    // Klick-Tracking für Links mit data-component="trackclick"
    document.querySelectorAll('a[data-component="trackclick"]').forEach(function (link) {
        link.addEventListener('click', function () {
            sendTrackingData ({
                url: link.getAttribute('href'),
                id: link.dataset.id,
                title: link.textContent.trim(),
                category: link.dataset.category
            });
        });
    });

    // Formular-Tracking bei Submit
    document.querySelectorAll('form').forEach(function (form) {
        form.addEventListener('submit', function () {
            const input = form.querySelector('input[data-component="trackclick"]');
            if (input) {
                sendTrackingData ({
                    id: input.dataset.id,
                    title: input.value,
                    category: input.dataset.category
                });
            }
        });
    });
});
